<template>
    <div class="container remove-padding-margin" id="logoutpage">
        <div class="fixed-top bg-white">
            <div class="nav-center pageDefault">
                <div class="row set-row d-flex">
                    <div class="remove-padding navbar-icon-left" @click="back">
                        <img class="remove-padding-margin" src="../../assets/gambar/back-blue.svg">
                    </div>
                    <div  class="text-center remove-padding flex-1 font-weight-600">
                        Paksa Logout Aplikasi
                    </div>
                    <div class="navbar-icon-right remove-padding">

                    </div>
                </div>
            </div>
        </div>
        <main class="">
            <div class="flex-100">
                <div class="flex-1 mar-top-60">
                    <div class="add-padding-default">
                        <div class="font-18 letter-space-002 line-height-28 color-0000"><span class="" style="margin-right: 8px"><img src="../../assets/img/smartlink-kasir.png" alt=""></span>Smartlik Kasir</div>
                        <div class="mar-top-16 font-14 line-height-21 letter-space-002 color-6f7">status</div>
                        <div id="kosongkasir">
                            <div class="color-0000 line-height-25 font-16 letter-space-002">Belum pernah login</div>
                        </div>
                        <div id="isikasir">
                            <div id="lastloginkasir" class="color-0000 line-height-25 font-16 letter-space-002"></div>
                            <div class="color-0000 line-height-25 font-16 letter-space-002 device"></div>
                            <div id="buttonkasir" style="display: none">
                                <button  type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="logoutkasir">Paksa logout dari aplikasi Kasir</button>
                            </div>
                        </div>
                    </div>
                    <div class="pembatas mar-top-20 mar-bottom-20"></div>
                    <div class="add-padding-default">
                        <div class="font-18 letter-space-002 line-height-28 color-0000"><span class="" style="margin-right: 8px"><img src="../../assets/img/smartlink-produksi.png" alt=""></span>Smartlik Produksi</div>
                        <div class="mar-top-16 font-14 line-height-21 letter-space-002 color-6f7">status</div>
                        <div id="kosongproduksi" >
                            <div class="color-0000 line-height-25 font-16 letter-space-002">Belum pernah login</div>
                        </div>
                        <div id="isiproduksi">
                            <div id="lastloginproduksi" class="color-0000 line-height-25 font-16 letter-space-002 lastlogin"></div>
                            <div class="color-0000 line-height-25 font-16 letter-space-002 device"></div>
                            <div id="buttonproduksi" style="display: none">
                                <button  type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="logoutworkshop">Paksa logout dari aplikasi Produksi</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    export default {
        name: "LogouPage",
        props:['setidkaryawan'],
        data(){
            return{
               datakaryawan:[],
               idkaryawan:this.setidkaryawan,
               karyawan:[],
               logtoken:[],
               requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }

            }
        },
        mounted(){
            this.idkaryawan = this.$route.params.idkaryawan
        },
        methods:{
            back(){
                this.$emit("isdetail")
            },

            async getdetailkaryawanlogout() {
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_karyawan_meta?idkaryawan=' + this.setidkaryawan, this.requestHeaders)
                    if (response.status === 200) {
                        this.karyawan = response.data.data;
                        var dataLog = response.data.log_token;
                        var lastlogin = response.data.last_login
                        $('.device').text(this.karyawan.device);
                        if(dataLog.length > 0){
                            for (var i = 0; i < dataLog.length; i++){
                                if (dataLog[i].idaplikasi === 1 ){
                                    $('#isikasir').show();
                                    $('#lastloginkasir').text('Terakhir Login '+ lastlogin.last_login_kasir);
                                    if(dataLog[i].valid ===1 && dataLog[i].hapus === 0){
                                        $('#buttonkasir').show();
                                        $('#lastloginkasir').text('Saat ini sedang Login ');
                                    }else{
                                        // $('#buttonkasir').hide();
                                    }
                                }else if(dataLog[i].idaplikasi === 2){
                                    $('#isiproduksi').show();
                                    $('#lastloginproduksi').text('Terakhir Login '+ lastlogin.last_login_produksi);
                                    if(dataLog[i].valid ===1 && dataLog[i].hapus === 0){
                                        $('#buttonproduksi').show();
                                        $('#lastloginproduksi').text('Saat ini sedang Login ');
                                    }else {
                                        // $('#buttonproduksi').hide();
                                    }
                                }
                            }
                        }else{
                            $('#kosongproduksi').show()
                            $('#kosongkasir').show()
                        }
                    }else{
                        //200 else
                    }
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide()
                    // this.isClicked = false;
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
                }
                $('#loadingPage').removeClass('overlayLoading');
                $('#loadingPage').hide()
                // this.isClicked = false;
            },

            async logoutkasir(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                try {
                    const logoutkasir = new FormData();
                    logoutkasir.append('idkaryawan', this.setidkaryawan)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/paksa_logout_dari_kasir' , logoutkasir,this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.back()
	                        this.$toast.success(response.data.msg)
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                        }else{
                        	this.$toast.error(response.data.msg)
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

            async logoutworkshop(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show();
                try {
                    const logoutworkshop = new FormData();
                    logoutworkshop.append('idkaryawan', this.setidkaryawan)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/karyawan/paksa_logout_dari_workshop?idkaryawan=' + this.setidkaryawan , logoutworkshop,this.requestHeaders)
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.back()
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
	                        this.$toast.success(response.data.msg)
                        }else{
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
	                        this.$toast.error(response.data.msg)
                        }
                    }
                }  catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
                }
            },

        }
    }
</script>

<style scoped>

</style>